import versionData from '@/version.json';
import * as Sentry from "@sentry/react";
import _ from "lodash";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

if (import.meta.env.VITE_ENVIRONMENT !== "development") {
  // Edit env name to match BE
  const env = import.meta.env.VITE_ENVIRONMENT === 'production' ? 'prod' : import.meta.env.VITE_ENVIRONMENT
  const environment = _.upperFirst(env)

  Sentry.init({
    dsn: "https://a6ad702d954fae44709c9fb8e16bddf8@sentry.docker01.cebia.cz/12",
    tunnel: import.meta.env.VITE_BASE_URL + "/tunnel",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: (event) => {
          // Do not capture fetch/xhr requests details, unless the response status code > 400
          if (
            event.data.tag === "performanceSpan" &&
            (event.data.payload.op === "resource.fetch" || event.data.payload.op === "resource.xhr") &&
            event.data.payload.data.statusCode < 400
          ) {
            if (event.data.payload.data.response)
              event.data.payload.data.response.body = null;

            if (event.data.payload.data.request)
              event.data.payload.data.request.body = null;
          }

          return event;
        },
        networkDetailAllowUrls: [window.location.origin],
        maskAllText: false,
        maskAllInputs: false,
      })
    ],

    // Change tracesSampleRate to 10 % for test and prep environments and 1 % for all other environments
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === "test" ? 1 : 0.02,

    // Přidává sentry hlavičky pro dané requesty
    tracePropagationTargets: [
      // /^\//
    ],

    // Change replaysSessionSampleRate to 33 % for test and prep environments and 1 % for all other environments
    replaysSessionSampleRate: import.meta.env.VITE_ENVIRONMENT === "test" ? 0.33 : 0.01,
    replaysOnErrorSampleRate: 1.0,

    // Vypne reporty, ktere nepodporuje self-hosted Sentry
    sendClientReports: false,

    environment,
    release: `OkApps@${versionData.version}`,
  })

  console.debug('Sentry is initialized.', import.meta.env.VITE_ENVIRONMENT)
}
else {
  console.debug("Sentry is disabled in development mode")
}
